import { FC } from "react";
import { observer } from "mobx-react-lite";
import { MDSPanelContainer } from "@/mds";
import { TemplatesListPageHeader } from "@/pages/templates-list/components/templates-list-page-header";
import { TemplatesListPageList } from "@/pages/templates-list/components/templates-list-page-list";
import { ShareSheetModal } from "@/components/modal/share-sheet/share-sheet-modal";
import { DeleteTemplateModal } from "@/components/modal/delete-template/delete-template-modal";
import { useTabPageStore } from "@/components/layout/components/tab-bar/use-tab-page-store";

export const TemplatesListPage: FC = observer(function TemplatesListPage() {
  const page = useTabPageStore("templatesListPage");

  return (
    <>
      <ShareSheetModal store={page.shareSheetModal} />
      <DeleteTemplateModal store={page.deleteTemplateModal} />
      <TemplatesListPageHeader />
      <MDSPanelContainer>
        <TemplatesListPageList />
      </MDSPanelContainer>
    </>
  );
});
